import { Star } from "lucide-react"

interface BrandRatingLineProps {
  brand: string
  rating: number
  reviewCount: number
  /** Additional classes on the wrapper */
  className?: string
}

export function BrandRatingLine({ brand, rating, reviewCount, className = "" }: BrandRatingLineProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-[#0469f0] font-bold text-sm tracking-tight uppercase">{brand}</span>
      <span className="w-1 h-1 rounded-full bg-gray-300" />
      <div className="flex items-center gap-1 text-[#ff9951]">
        <Star className="w-4 h-4 fill-current" />
        <span className="text-xs font-bold text-black">
          {rating} ({reviewCount} reviews)
        </span>
      </div>
    </div>
  )
}
